export class BusinessAccountLite {
    id: string;
    ragioneSociale: string;
}